/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * This is the OpenAPI Document on Azure Functions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParsedFieldBoolean } from './ParsedFieldBoolean';
import {
    ParsedFieldBooleanFromJSON,
    ParsedFieldBooleanFromJSONTyped,
    ParsedFieldBooleanToJSON,
} from './ParsedFieldBoolean';
import type { ParsedFieldString } from './ParsedFieldString';
import {
    ParsedFieldStringFromJSON,
    ParsedFieldStringFromJSONTyped,
    ParsedFieldStringToJSON,
} from './ParsedFieldString';

/**
 * 
 * @export
 * @interface PartialBranch
 */
export interface PartialBranch {
    /**
     * 
     * @type {string}
     * @memberof PartialBranch
     */
    id?: string;
    /**
     * 
     * @type {ParsedFieldString}
     * @memberof PartialBranch
     */
    clientReference?: ParsedFieldString;
    /**
     * 
     * @type {ParsedFieldString}
     * @memberof PartialBranch
     */
    fullName?: ParsedFieldString;
    /**
     * 
     * @type {ParsedFieldString}
     * @memberof PartialBranch
     */
    abbreviatedName?: ParsedFieldString;
    /**
     * 
     * @type {ParsedFieldString}
     * @memberof PartialBranch
     */
    branchNameFull?: ParsedFieldString;
    /**
     * 
     * @type {ParsedFieldString}
     * @memberof PartialBranch
     */
    branchNameAbbreviated?: ParsedFieldString;
    /**
     * 
     * @type {ParsedFieldString}
     * @memberof PartialBranch
     */
    reliability?: ParsedFieldString;
    /**
     * 
     * @type {ParsedFieldBoolean}
     * @memberof PartialBranch
     */
    isActive?: ParsedFieldBoolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartialBranch
     */
    hasParseErrors?: boolean;
}

/**
 * Check if a given object implements the PartialBranch interface.
 */
export function instanceOfPartialBranch(value: object): value is PartialBranch {
    return true;
}

export function PartialBranchFromJSON(json: any): PartialBranch {
    return PartialBranchFromJSONTyped(json, false);
}

export function PartialBranchFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartialBranch {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'clientReference': json['clientReference'] == null ? undefined : ParsedFieldStringFromJSON(json['clientReference']),
        'fullName': json['fullName'] == null ? undefined : ParsedFieldStringFromJSON(json['fullName']),
        'abbreviatedName': json['abbreviatedName'] == null ? undefined : ParsedFieldStringFromJSON(json['abbreviatedName']),
        'branchNameFull': json['branchNameFull'] == null ? undefined : ParsedFieldStringFromJSON(json['branchNameFull']),
        'branchNameAbbreviated': json['branchNameAbbreviated'] == null ? undefined : ParsedFieldStringFromJSON(json['branchNameAbbreviated']),
        'reliability': json['reliability'] == null ? undefined : ParsedFieldStringFromJSON(json['reliability']),
        'isActive': json['isActive'] == null ? undefined : ParsedFieldBooleanFromJSON(json['isActive']),
        'hasParseErrors': json['hasParseErrors'] == null ? undefined : json['hasParseErrors'],
    };
}

export function PartialBranchToJSON(value?: PartialBranch | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'clientReference': ParsedFieldStringToJSON(value['clientReference']),
        'fullName': ParsedFieldStringToJSON(value['fullName']),
        'abbreviatedName': ParsedFieldStringToJSON(value['abbreviatedName']),
        'branchNameFull': ParsedFieldStringToJSON(value['branchNameFull']),
        'branchNameAbbreviated': ParsedFieldStringToJSON(value['branchNameAbbreviated']),
        'reliability': ParsedFieldStringToJSON(value['reliability']),
        'isActive': ParsedFieldBooleanToJSON(value['isActive']),
        'hasParseErrors': value['hasParseErrors'],
    };
}

